interface UniqIdMarked {
	uniqId:number;
}